import { RodRequestFilterByTerm, SortOrder, RodRequestSortByTerm } from '@bechtel/types';

export enum PickupTimeTerm {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  PAST_DAYS = 'PAST_DAYS',
}

export interface RodRequestDrawerValuesProps {
  searchByList: RodRequestFilterByTerm[];
  sortBy: RodRequestSortByTerm;
  sortDir: SortOrder;
  pickupTimeList: PickupTimeTerm[];
}

export interface RodRequestDrawerProps {
  close: () => void;
  initialValues: RodRequestDrawerValuesProps;
  onSubmit: (values: RodRequestDrawerValuesProps) => void;
}
